import { Component } from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';
import { Button } from './ui/Button';

/**
 * Jaring pengaman terakhir. Tanpa ini, satu galat render di komponen mana pun
 * akan membuat React melepas seluruh pohon dan pengguna melihat halaman putih
 * kosong tanpa penjelasan apa pun.
 */
export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Di produksi, di sinilah galat dikirim ke layanan pemantauan.
    console.error('Galat render tak tertangani:', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="flex min-h-screen items-center justify-center bg-[var(--surface-canvas)] px-4">
        <div className="w-full max-w-md rounded-2xl border border-[var(--border-subtle)] bg-[var(--surface-raised)] p-7 text-center shadow-sm">
          <div className="mx-auto grid size-12 place-items-center rounded-xl bg-danger-50 text-danger-600 dark:bg-danger-500/15 dark:text-danger-500">
            <AlertTriangle className="size-6" aria-hidden="true" />
          </div>

          <h1 className="mt-4 text-lg font-bold text-[var(--text-primary)]">
            Ada yang tidak beres
          </h1>
          <p className="mt-2 text-sm leading-relaxed text-[var(--text-muted)]">
            Halaman ini gagal ditampilkan. Coba muat ulang - kalau masih berlanjut, hubungi tim
            dukungan kami.
          </p>

          <div className="mt-6 flex justify-center gap-2">
            <Button icon={RotateCcw} onClick={() => window.location.reload()}>
              Muat ulang halaman
            </Button>
            <Button variant="secondary" onClick={() => (window.location.href = '/dashboard')}>
              Ke Dashboard
            </Button>
          </div>

          {import.meta.env.DEV && (
            <details className="mt-5 text-left">
              <summary className="cursor-pointer text-xs font-semibold text-[var(--text-muted)]">
                Detail galat (hanya tampil saat development)
              </summary>
              <pre className="mt-2 max-h-48 overflow-auto rounded-lg bg-[var(--surface-sunken)] p-3 font-mono text-[11px] whitespace-pre-wrap text-danger-600">
                {this.state.error.stack ?? String(this.state.error)}
              </pre>
            </details>
          )}
        </div>
      </div>
    );
  }
}
